<template>
  <div target="_blank" class="course-item">
    <div class="course-pic">
      <img
        class="coursePic"
        :src="courseItem.logoPath | filterImageBaseURL(imgUrl)"
        alt="易极云课堂"
      />
      <div
        class="isDiscount"
        v-if="
          courseItem.isDiscount == 1 &&
            (courseItem.discountType == 2 || courseItem.discountType == 1)
        "
      >
        <span
          v-if="courseItem.currentPrice !== 0 && courseItem.discountType == 1"
          >限时优惠</span
        >
        <span
          v-if="courseItem.currentPrice !== 0 && courseItem.discountType == 2"
          >限量优惠</span
        >
        <span
          v-if="courseItem.currentPrice == 0 && courseItem.discountType == 1"
          >限时免费</span
        >
        <span
          v-if="courseItem.currentPrice == 0 && courseItem.discountType == 2"
          >限量免费</span
        >
      </div>
    </div>
    <i class="typeIcon">{{ courseItem.courseTypeName }}</i>
    <p class="name">{{ courseItem.name | ellipsis }}</p>
    <!--<span class="current-price" v-if="courseItem.currentPrice!==0">{{ courseItem.currentPrice }}</span>-->
    <!--<span class="free" v-else>免费</span>-->
    <!--&lt;!&ndash;<span class="old-price"  v-if="courseItem.oldPrice && courseItem.oldPrice!=0 && courseItem.oldPrice > courseItem.currentPrice">{{ courseItem.oldPrice }}</span>&ndash;&gt;-->
    <!--<span class="old-price"  v-if="courseItem.isDiscount==1 && courseItem.oldPrice && courseItem.oldPrice!=0">{{ courseItem.oldPrice }}</span>-->
    <!--<span class="old-pricebhx"  v-if="courseItem.isDiscount!=1 && courseItem.oldPrice && courseItem.oldPrice!=0 && (courseItem.oldPrice!=courseIntro.currentPrice)">{{ courseItem.oldPrice }}</span>-->
    <template v-if="courseItem.isHighSchool !== 1">
      <span
        class="current-price"
        v-if="courseItem.isFree == 0 && courseItem.isDiscount == 0"
        >{{ courseItem.oldPrice == 0 ? "免费" : courseItem.oldPrice }}</span
      >
      <span
        class="current-price"
        v-else-if="courseItem.isFree == 0 && courseItem.isDiscount == 1"
        >{{
          courseItem.currentPrice == 0 ? "免费" : courseItem.currentPrice
        }}</span
      >
      <span class="free" v-else>免费</span>
      <!--<span class="old-price"  v-if="courseItem.oldPrice && courseItem.oldPrice!=0 && courseItem.oldPrice > courseItem.currentPrice">{{ courseItem.oldPrice }}</span>-->
      <span
        class="old-price"
        v-if="
          courseItem.isDiscount == 1 &&
            courseItem.oldPrice &&
            courseItem.oldPrice != 0 &&
            courseItem.currentPrice !== 0
        "
        >{{ courseItem.oldPrice == 0 ? "免费" : courseItem.oldPrice }}</span
      >
      <span
        class="old-pricebhx"
        v-if="
          courseItem.isDiscount != 1 &&
            courseItem.oldPrice &&
            courseItem.oldPrice != 0 &&
            courseItem.oldPrice != courseItem.currentPrice &&
            courseItem.currentPrice !== 0
        "
        >{{ courseItem.oldPrice == 0 ? "免费" : courseItem.oldPrice }}</span
      >
      <span class="number"
        ><i class="iconfont icon-ren"></i>{{ courseItem.baseSaleNum }}</span
      >
    </template>
  </div>
</template>

<script>
import global from "@/common/js/global";
export default {
  //   id: data.id,
  // name: data.name,
  // description: data.description,
  // courseTypeName: data.courseTypeName,
  // headerImgPath: data.headerImgPath,
  // currentPrice: data.currentPrice,
  // saleNum: data.saleNum
  props: {
    courseItem: {
      type: Object,
      default: function() {
        return {
          id: "0",
          logoPath: "",
          name: "学会计到新东方",
          currentPrice: "199.00",
          saleNum: "999",
          courseTypeName: "财会",
          isDiscount: 0,
          discountType: 0
        };
      }
    }
  },
  data() {
    return {
      imgUrl: global.imgUrl
    };
  },

  filters: {
    ellipsis: function(value) {
      if (!value) return "";
      if (value.length > 16) {
        return value.slice(0, 16) + "...";
      }
      return value;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/scss" lang="scss" scoped>
@import "~@/styles/base.scss";
.course-item {
  position: relative;
  display: block;
  height: 240px;
  // box-shadow: 0 2px 4px #eee;
  .course-pic {
    position: relative;
    height: 140px;
    overflow: hidden;
    img {
      width: 100%;
      /*height: 170px;*/
    }
    .isDiscount {
      position: absolute;
      left: 10px;
      top: 10px;
      padding: 0 5px 0 5px;
      color: white;
      background-color: rgba(251, 118, 91, 1);
      border: 1px rgba(251, 118, 91, 1) solid;
      border-radius: 2px;
    }
  }
  .typeIcon {
    display: block;
    position: absolute;
    top: 104px;
    right: 10px;
    padding: 0 7px;
    line-height: 24px;
    border-radius: 12px;
    text-align: center;
    color: #fff;
    background-color: rgba(0, 0, 0, 0.4);
  }
  .name {
    margin: 20px 0;
    font-size: 16px;
    color: #333;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .current-price,
  .free,
  .old-price {
    float: left;
    color: #fe1111;
    letter-spacing: 0;
    font-size: 14px;
  }
  .current-price,
  .old-price {
    &:before {
      content: "￥";
    }
  }
  .current-price,
  .old-pricebhx {
    &:before {
      content: "￥";
    }
  }
  .old-price {
    margin-left: 7px;
    color: #787878;
    text-decoration: line-through;
  }
  .old-pricebhx {
    margin-left: 7px;
    color: #787878;
  }
  .number {
    float: right;
    color: #9f9fa0;
    font-size: 10px;
    position: relative;
    letter-spacing: 0;
    font-size: 14px;
    .iconfont {
      position: absolute;
      left: -17px;
      top: 0px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/course-item/course-item.vue